'use client';

import LogoLink from './components/LogoLink';
import NavigationMenu from './components/NavigationMenu';
import MobileMenu from './components/MobileMenu';
import type { NavigationItem } from './links';
import styles from './header.module.scss';
import DemoButton from '@/components/buttons/DemoButton';
import HomepageSummitBanner from '@/components/HomepageSummitBanner/HomepageSummitBanner';
import { useHeaderDarkSection } from '@/hooks/useHeaderDarkSection';
import { usePathname } from 'next/navigation';

type HeaderProps = {
  navItems: NavigationItem[];
};

export default function Header({ navItems }: HeaderProps) {
  const isHomepage = usePathname() === '/';
  const { headerRef, isDarkSection } = useHeaderDarkSection({
    targetId: 'site-footer'
  });

  const header = (
    <header
      ref={headerRef}
      className={styles.header}
      data-dark-section={isDarkSection}
    >
      <div className={styles.content}>
        <LogoLink isDarkSection={isDarkSection} />
        <NavigationMenu navItems={navItems} />
        <div className={styles.header__right}>
          <div className={styles.demoButton}>
            <DemoButton />
          </div>
          <MobileMenu navItems={navItems} />
        </div>
      </div>
    </header>
  );

  if (!isHomepage) return header;

  return (
    <div className={styles.homepageStack}>
      <HomepageSummitBanner />
      {header}
    </div>
  );
}
